var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaffContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#E5E7DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6572 10.9258C15.7447 10.9152 16.6719 11.7124 16.8252 12.7969C16.9014 13.3746 17.0421 13.9422 17.2451 14.4863L17.2959 14.6357C17.5179 15.3884 17.3155 16.2085 16.7549 16.7754L16.3721 17.1572L16.5762 17.457C17.2773 18.4433 18.1552 19.2933 19.166 19.9619L19.1943 19.9785L19.5791 19.5938C20.1429 19.0362 20.9628 18.8342 21.7139 19.0557L22.1934 19.2197C22.6367 19.3626 23.0935 19.4656 23.5615 19.5273C24.6509 19.681 25.4528 20.6269 25.4258 21.7061V23.7021C25.4283 24.3121 25.1731 24.8952 24.7236 25.3076C24.2741 25.72 23.6714 25.9245 23.0488 25.8682C20.8679 25.6312 18.7726 24.8857 16.9385 23.6963C15.2244 22.6071 13.7708 21.1532 12.6855 19.4453C11.4879 17.5964 10.7427 15.4907 10.5088 13.2871C10.4542 12.6816 10.6565 12.0809 11.0664 11.6318C11.4763 11.1828 12.0561 10.9266 12.665 10.9258H14.6572ZM12.666 12.5928C12.5257 12.5931 12.3924 12.6523 12.2979 12.7559C12.2032 12.8595 12.1566 12.9982 12.168 13.125C12.373 15.0553 13.0295 16.9105 14.0889 18.5459C15.0467 20.0533 16.325 21.3309 17.8389 22.293C19.4608 23.3448 21.307 24.0016 23.2139 24.209C23.354 24.2216 23.493 24.1751 23.5967 24.0801C23.7004 23.9849 23.7593 23.8502 23.7588 23.7061V21.6855C23.7651 21.4319 23.5807 21.2133 23.3369 21.1787C22.6347 21.0861 21.9448 20.9143 21.2793 20.666C21.0966 20.5973 20.8904 20.6414 20.7549 20.7754L19.9082 21.6221C19.643 21.8872 19.2333 21.9421 18.9072 21.7568C17.1078 20.7337 15.6179 19.2438 14.5947 17.4443C14.4093 17.1183 14.4643 16.7086 14.7295 16.4434L15.5732 15.5996C15.7103 15.4608 15.7539 15.2548 15.6846 15.0703C15.437 14.4067 15.2654 13.717 15.1738 13.0225C15.1387 12.774 14.9247 12.5904 14.6738 12.5928H12.666Z",
    fill: "#8CAEB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffContactIcon);
export default __webpack_public_path__ + "static/media/staffContactIcon.bd04cd4bd6b8bdb61cf293d2b20f9f21.svg";
export { ForwardRef as ReactComponent };